import React from 'react';
import styled from 'styled-components';

import flexGap from '../functions/flexGap';

import { Title, Paragraph, Label } from '../helpers/Text';
import Number from '../helpers/Number';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${flexGap(20)};
`;

const Item = styled.div`
  display: flex;
  align-items: center;

  ${flexGap(10)};

  transition: opacity 500ms;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
`;

const ImageWrapper = styled.div`
  flex: 0 0 auto;
  position: relative;
  width: 100%;
  max-width: 60px;
  border-radius: ${({ theme }) => theme.roundness.cart.image}px;
  overflow: hidden;
`;

const ImageHeight = styled.div`
  width: 100%;
  padding-top: ${({ theme }) => theme.aspectRatio}%;
`;

const Image = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  object-fit: ${({ theme }) => theme.imageSizing.card};
`;

const Shade = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: hsla(0, 0%, 0%, 0.02);
`;

const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  & > * {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 0 0 auto;

  ${flexGap(3)};

  padding-left: 10px;
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;

  ${flexGap(10)};
`;

const NumberItemQuantity = styled(Number)`
  min-width: 20px;
  text-align: center;
`;

const Items = ({ items, store }) => (
  <Wrapper>
    {items.map(({
      sku,
      quantity,
      price,
      name,
      image,
      variationName: variation,
      // meta: {
      //   name: productName,
      //   variation,
      //   tagline,
      //   image,
      //   productSlug,
      //   variationSlug,
      // },
    }) => (
      <Item key={sku}>
        <ImageWrapper>
          <ImageHeight />
          <Image src={image.src} />
          <Shade />
        </ImageWrapper>
        <Content>
          <Title
            style={{ margin: 0, marginTop: 10 }}
            fontSize={20}
            title={name}
          >
            {name}
          </Title>
          <Paragraph
            fontSize={12}
            opacity={0.6}
            title={variation}
          >
            {variation}
          </Paragraph>
        </Content>
        <Actions style={{ opacity: 0.8 }}>
          <Controls>
            <Paragraph as="div">
              <NumberItemQuantity
                number={`x ${quantity}`}
                quick
              />
            </Paragraph>
          </Controls>
          <Label as="div" style={{ letterSpacing: 2 }}>
            { /** TODO: do properly */ }
            <Number
              key={price}
              number={`${store.systemCountry === 'om'
              ? 'OMR' : 'AED'} ${price}.00`}
              // number={
              //   <PriceWithCurrency value={priceTotal} />
              // }
            />
          </Label>
        </Actions>
      </Item>
    ))}
  </Wrapper>
);

export default Items;
